import { Injectable } from "@angular/core";
import { Observable, timer } from "rxjs";
import { map, shareReplay, takeWhile } from "rxjs/operators";
import { UtilityService } from "../core/services/utility.service";

/* This service provides a countdown for the current date/time to the provided EndDate.
 * The EndDate should be in the future otherwise this will not return any values. 
 * Adapted from: https://medium.com/@alanasmis15/make-an-easy-countdown-service-in-angular-a8176413beaf
 * */

@Injectable()
export class CountdownService {

    private _countdown$: Observable<IInterval>;
    private _endDate: Date;
    constructor(private utility: UtilityService) { }

    public CountDown$(endDate: Date): Observable<IInterval> {        
        if (this._countdown$ && this._endDate && this._endDate.getTime() == endDate.getTime()) {            
        } else {           
            // getTime() always uses UTC for time representation. For example, a client browser in one timezone, getTime() will be the same as a client browser in any other timezone.
            // Date.now() method returns the number of milliseconds elapsed since January 1, 1970 00:00:00 UTC.
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
            var timeToGo = endDate.getTime();
            this._endDate = endDate;
            this._countdown$ = timer(0, 1000)
                .pipe(
                map(x => { return this.getIntervalTime(timeToGo, this.utility.getCurrentDate().getTime()) }),                    
                    takeWhile(x => this.validIntervalCountdown(timeToGo)),
                    shareReplay(1)
                )
        }
        return this._countdown$;
    }
    
    private getIntervalTime(dateA: number, dateB: number): IInterval {              
        let intervalTime: number = Math.floor((dateA - dateB) / 1000);        
        return this.getTime(intervalTime);
    }

    private getTime(time: number): IInterval {
        let interval: IInterval =
            { months: 0, days: 0, hours: 0, minutes: 0, seconds: 0, shortTime: 0, displayString: "" };
        interval.months = Math.floor(time / 2592000);
        if (interval.months > 0) {
            interval.shortTime = interval.months;
            interval.displayString = 'months';
        }
        time -= interval.months * 2592000;
        interval.days = Math.floor(time / 86400);
        if (interval.months == 0 && interval.days > 0) {
            interval.shortTime = interval.days;
            interval.displayString = 'days';
        }            
        time -= interval.days * 86400;
        interval.hours = Math.floor(time / 3600) % 24;
        if (interval.days == 0 && interval.hours > 0) {
            interval.shortTime = interval.hours;
            interval.displayString = 'hours';
        }            
        time -= interval.hours * 3600;
        interval.minutes = Math.floor(time / 60) % 60;
        if (interval.days == 0 && interval.hours == 0 && interval.minutes > 0) {
            interval.shortTime = interval.minutes;
            interval.displayString = 'minutes';
        }            
        time -= interval.minutes * 60;
        interval.seconds = time % 60;
        if (interval.days == 0 && interval.hours == 0 && interval.minutes == 0 && interval.seconds > 0) {
            interval.shortTime = interval.seconds;
            interval.displayString = 'seconds';
        }            
        return interval;
    }

    private validIntervalCountdown(timeToGo):boolean {       
        return (timeToGo - this.utility.getCurrentDate().getTime()) >= 0 ? true : false;
    }
}

export interface IInterval {
    months: number;
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    shortTime: number;
    displayString: string;
}
